import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { throwError } from 'rxjs';
import { environment } from '../environments/environment';

import { AppModule } from './app/app.module';

// TODO: This will be refactored out and pared down to standard angular main.ts
// We should not be imoprting a config ahead of angular being bootstrapped.

if (environment.production) {
  enableProdMode();
}

export const main = () =>
  new Promise((resolve) => {
    // let appConfig: any;
    const url = `/assets/data/config.json`;
    // Need for cache busting
    const datetime = new Date().toISOString();
    const cbURL = `${url}?cb=${datetime}`;
    const request: XMLHttpRequest = new XMLHttpRequest();
    const reqState200 = 200;
    const reqState304 = 304;

    request.open('GET', cbURL, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request.onerror = (error: any) => {
      console.error('Error reading configuration file');
      resolve(error);
      return throwError(error.json().error || 'Server error');
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSuccess = (responseData: any) => {
      const parsed = JSON.parse(responseData);
      Object.assign(environment, parsed);
      return platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .catch((e) => console.error(e));
    };
    request.onreadystatechange = () => {
      if (request.status === reqState200 || request.status === reqState304) {
        onSuccess(request.response);
      }
    };

    // if (request.OPENED)
    request.send(null);
  });

if (document.readyState === 'complete') {
  main();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    main();
  });
}
